import { enablePagination } from "./enablePagination";
import { Store } from "../classes/Store";

export async function startSearch(store: Store) {
  const res = await fetch(
    `/wp-json/api/search${new URL(window.location.href).search}`
  );
  const resultsContainer = document.getElementById("properties-list");
  if (resultsContainer) {
    resultsContainer.outerHTML = await res.text();
    enablePagination(store);
  }
}
